import { useRef } from 'react';
import { useRefCallback } from '../../../callback/ref-callback';
import { useRefGetter } from '../../use';
import { getDefaultElementSize } from '../../co-dom';
import { useWindowSize } from './useWindowSize';
import { matchBreakpoints } from './useElementResponsive';
export function useWindowResponsive(enable, breakpoints, onBreakpointChange) {
  var range = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var lastElementSize = useRef(range ? getDefaultElementSize() : undefined);
  var breakpointsRefGetter = useRefGetter(breakpoints);
  var onBreakpointChangeCallback = useRefCallback(onBreakpointChange);
  useWindowSize(enable, function (size) {
    var bkList = breakpointsRefGetter();

    if (bkList.length === 0) {
      return;
    }

    var lastSize = lastElementSize.current || size;

    if (!lastElementSize.current) {
      lastElementSize.current = size;
      return;
    }

    var matched = matchBreakpoints(bkList, size.width, lastSize.width);

    if (matched != null) {
      onBreakpointChangeCallback(matched);
    }

    lastElementSize.current = size;
  });
}